import get from 'lodash/get';
import {
  FETCH_ONLINE_REVIEW_DATA_CAMPAIGN,
  FETCH_ONLINE_REVIEW_DATA_PAGE_TYPE,
  FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN,
  fetchOnlineReviewActionType
} from '../actionTypes';

export const startFetchingOnlineReviewData = () => {
  return {
    type: fetchOnlineReviewActionType.START_FETCHING_ONLINE_REVIEW_DATA
  };
};
export const successFetchingOnlineReviewData = payload => {
  return {
    type: fetchOnlineReviewActionType.SUCCESS_FETCHING_ONLINE_REVIEW_DATA,
    payload
  };
};
export const failureFetchingOnlineReviewData = payload => {
  return {
    type: fetchOnlineReviewActionType.FAILURE_FETCHING_ONLINE_REVIEW_DATA,
    payload
  };
};
export const clearOnlineReviewData = payload => {
  return {
    type: fetchOnlineReviewActionType.CLEAR_ONLINE_REVIEW_DATA,
    payload
  };
};

export const fetchOnlineReviewData = payload => dispatch => {
  const { filters, benchmark } = payload;

  // dispatch(clearOnlineReviewData());
  dispatch(startFetchingOnlineReviewData());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      body: {
        filters: filters,
        // filters: {
        //   start_date: '2025-08-04',
        //   end_date: '2025-11-15',
        //   additional_filters: {
        //     property_id: ['M69215']
        //   }
        // },
        benchmark
      },
      queryParams: {
        page_type: FETCH_ONLINE_REVIEW_DATA_PAGE_TYPE,
        campaign: FETCH_ONLINE_REVIEW_DATA_CAMPAIGN
      }
    },
    onSuccess: ({ data }) => {
      const widgetList = get(data, 'data.widget_list[0].contents.contents');
      dispatch(successFetchingOnlineReviewData(widgetList));
    },
    onError: ({ error }) => {
      dispatch(failureFetchingOnlineReviewData({ error }));
    }
  });
};



export const fetchOnlineReviewByPropertiesData = payload => dispatch => {

  const { onSuccess, campaign, offset, limit, onError, filters } = payload;
  const { filters: t, benchmark } = filters;

  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      body: {
        filters: t,
        benchmark
      },
      queryParams: {
        page_type: FETCH_ONLINE_REVIEW_DATA_PAGE_TYPE,
        campaign: campaign
      }
    },
    onSuccess: ({ data }) => {
      const topicData = get(data, 'data.widget_list[0].contents', {});
      onSuccess(topicData);
    },
    onError: ({ error }) => {
      onError && onError(error);
    }
  });
};